module.exports = __webpack_public_path__ + "static/media/salon.4da8642a.webp";